import Vue from "vue";
import Router from "vue-router";
import mainRouter from "@/views/main/router";
import adminSystemRouter from "@/views/admin/system/router";

Vue.use(Router);
let routes = [...mainRouter, ...adminSystemRouter];
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default new Router({
  routes,
});
